import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { firestore } from "../../db/config";

import moment from "moment";
export default function RenderAdminMessage() {
  const dispatch = useDispatch()
  const [userMessage, setuserMessage] = useState([]);
  const messageRef = useRef();
  const userRandomNumber = JSON.parse(
    localStorage.getItem("persist:userNumber")
  );

  const getRendomNumber = JSON.parse(userRandomNumber.getChatClickReducer);
  const userId = getRendomNumber.user;
  useEffect(() => {
    firestore
      .collection("customerMessages")
      .doc(String(userId))
      .collection("messages")
      .orderBy("createdAt", "asc")
      .onSnapshot((snapShot) => {
        const getMessages = snapShot.docs.map((message) => message.data());
        setuserMessage(getMessages);

      });
  }, []);
//  const getUnreadMessage=userMessage?userMessage.find(unreadMessage=>unreadMessage.fromUser===String(userId)&&unreadMessage.read===false):"";
//  console.log(getUnreadMessage);

  useEffect(() => {
   
    if (messageRef.current) {
      messageRef.current.scrollIntoView({
        behavior: "smooth",
        block: "end",
        inline: "nearest",
      });
      
    }
   
  });
  return (
    <div ref={messageRef}>
      {userMessage.length
        ? userMessage.map((message) => {
            if (message.fromUser === "admin") {
              return (
                <div class="container1">
                  <img src="images/admin-image.jpg" alt="Avatar" />
                  <p>{message.message}</p>
                  <span class="time-right">
                    Delivered {message.deliveredTime}
                  </span>
                </div>
              );
            } else {
              return (
                <div class="container1 darker">
                  <img src="images/user.png" alt="Avatar" class="right" />
                  <p>{message.message}</p>
                  <span class="time-left">
                    Delivered {message.deliveredTime}
                  </span>
                </div>
              );
            }
          })
        : ""}
    </div>
  );
}
